import { getIndonesianTimezone } from "utils/utils";
import { useJadwalChanges } from "../hooks/use-jadwal-changes";
import JadwalChangesInfo from "./jadwal-changes-info";
import { JadwalChangesContainer } from "./jadwal-changes-info.styles";
import { convertScheduleToTimezone } from "./jadwal-changes.helpers";

interface Props {
  timezone?: string;
  timezoneSuffix?: string;
}

const JadwalChangesInfoFromFeature: React.FC<Props> = ({
  timezone,
  timezoneSuffix
}) => {
  const { on: isJadwalChangesFeatureOn, value: jadwalChangesFeatureValue } =
    useJadwalChanges();

  return isJadwalChangesFeatureOn && jadwalChangesFeatureValue ? (
    <JadwalChangesContainer>
      <JadwalChangesInfo
        data={{
          ...jadwalChangesFeatureValue,
          schedule: convertScheduleToTimezone(
            jadwalChangesFeatureValue.schedule,
            timezone
          )
        }}
        timezone={timezoneSuffix || getIndonesianTimezone()}
      />
    </JadwalChangesContainer>
  ) : (
    <></>
  );
};

export default JadwalChangesInfoFromFeature;
